import { type Repub, type RepubConfig, REPUBS } from '@cx-modules/constants';

export function getRepubConfigByName(repub: Repub): RepubConfig {
  return REPUBS[repub] ?? REPUBS.OC;
}
